export const SLOW_SPEED = 50
export const UNSTABLE_SPEED = 5
export const One_Mbps_To_Byte = 125000
export const NETWORK_TYPE_MOBILE = 'Mobile Data'
export const NETWORK_TYPE_WI_FI = 'WiFi'
export const UPLOAD = 'Upload'
export const DOWNLOAD = 'Download'
export const PING = 'Ping'
export const LOCALE = 'locale'
